"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TriangleExclamationMark42Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 42, height: 42, viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.767 6.35164C22.0165 4.92966 19.9799 4.92966 19.2294 6.35164L3.54646 36.0668C2.84351 37.3987 3.80921 39.0003 5.31524 39.0003H36.6812C38.1872 39.0003 39.1529 37.3987 38.45 36.0668L22.767 6.35164ZM36.6812 37.0003H5.31523L20.9982 7.28516L36.6812 37.0003ZM19.9982 17.0003H21.9982V26.0003H19.9982V17.0003ZM20.9982 33.0003C22.1028 33.0003 22.9982 32.1049 22.9982 31.0003C22.9982 29.8957 22.1028 29.0003 20.9982 29.0003C19.8936 29.0003 18.9982 29.8957 18.9982 31.0003C18.9982 32.1049 19.8936 33.0003 20.9982 33.0003Z", fill: "#383F49" }));
}
function TriangleExclamationMark42(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TriangleExclamationMark42Svg, Object.assign({}, svgProps)));
}
exports.default = TriangleExclamationMark42;
//# sourceMappingURL=TriangleExclamationMark42.js.map